/**
 * Feature flags del frontend.
 *
 * MVP: el Copiloto Contable (ORR-5) solo está habilitado para una lista
 * de emails configurada via `VITE_COPILOTO_ALLOWED_EMAILS` (CSV).
 *
 * Cuando el MVP salga de beta, esta lógica se reemplaza por un check
 * contra un campo en la tabla de organizaciones o por role-based.
 */

import type { User } from '@auth0/auth0-react'

const RAW_ALLOWED = (import.meta.env.VITE_COPILOTO_ALLOWED_EMAILS as string | undefined) ?? ''

export const COPILOTO_ALLOWED_EMAILS: string[] = RAW_ALLOWED
  .split(',')
  .map((e) => e.trim().toLowerCase())
  .filter(Boolean)

/**
 * Devuelve true si el usuario logueado puede acceder al Copiloto Contable.
 * Comparación case-insensitive.
 */
export const isCopilotoEnabled = (user: User | null | undefined): boolean => {
  if (!user?.email) return false
  if (COPILOTO_ALLOWED_EMAILS.length === 0) return false
  return COPILOTO_ALLOWED_EMAILS.includes(user.email.toLowerCase())
}

/**
 * URL base del ai-server (Railway). Si no está configurada, el copiloto
 * no puede funcionar — la página debería mostrar un mensaje de "no configurado".
 */
export const AI_SERVER_URL = (import.meta.env.VITE_AI_SERVER_URL as string | undefined) ?? ''
